import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui'
import axios from './config/httpConfig'
import signManager from './config/signManager'
Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css'
import './style/index.scss'
import './style/style.scss'
Vue.prototype.$http = axios;

Vue.prototype.signManager = signManager //全局对象

Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
  //判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    if(localStorage.getItem('tokenInfo')){
      next()
    }
    else {
      next()
      // next({
      //   path: '/login'
      // })
    }
  }
  else {
    next();
  }
  next();
});


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
